<template>
  <div>
    <label style="color:grey;">{{ fieldLabel }}</label>

    <template v-if="requiredField">

      <v-textarea
        v-model="extraFieldsValue.value"
        clearable
        clear-icon="cancel"
        required
        :rules="[rules.requiredValue]"
      />
    </template>
    <template v-else>

      <v-textarea
        v-model="extraFieldsValue.value"
        clearable
        clear-icon="cancel"
      />
    </template>

  </div>
</template>
<script>
export default {
  name: 'Comment',
  props: {
    isrequired: {
      type: Boolean,
      default: false
    },
    fieldLabel: {
      type: String,
      default: ''
    },
    extraFieldsValue: {
      type: Object,
      default: () => { return {} }

    }
  },
  data () {
    return {
      rules: {
        requiredValue: value => !!value || 'This field is required'
      }
    }
  },
  computed: {
    requiredField () {
      if (typeof this.isrequired !== 'undefined') {
        return this.isrequired
      } else {
        return false
      }
    }
  }
}
</script>
